var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4522 8.30197C16.4522 3.77324 12.781 0.101974 8.25225 0.101974C3.72351 0.101974 0.0522461 3.77324 0.0522461 8.30197C0.0522461 12.3948 3.05087 15.7872 6.971 16.4024V10.6723H4.88896V8.30197H6.971V6.49541C6.971 4.44029 8.1952 3.3051 10.0683 3.3051C10.9654 3.3051 11.9038 3.46526 11.9038 3.46526V5.48322H10.8698C9.85117 5.48322 9.5335 6.11531 9.5335 6.76379V8.30197H11.8077L11.4442 10.6723H9.5335V16.4024C13.4536 15.7872 16.4522 12.3948 16.4522 8.30197Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFb);
export default __webpack_public_path__ + "static/media/icon-fb.7e76d5fce7742da193b4900dac5e30a6.svg";
export { ForwardRef as ReactComponent };